import axios from 'axios';
import { UserResume } from '@addviseo/shared/types';
import { normalizeFile } from '@/utils/file-name';

export const uploadResume = async (file: File, { parse = false }: { parse?: boolean } = {}) => {
  const normalizedFile = normalizeFile(file);

  const formData = new FormData();
  formData.append('file', normalizedFile);
  formData.append('parse', String(parse));
  return axios
    .post('/api/user/upload-resume', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => response.data);
};

export const deleteResume = async (fileName: string) => {
  return axios
    .delete('/api/user/delete-resume', {
      data: { fileName },
    })
    .then((response) => response.data);
};

export const getUserResumes = async () => {
  return axios.get<UserResume[]>('/api/user/resumes').then((response) => response.data);
};

export const setFeaturedResume = async (resumeId: number | null) => {
  return axios
    .post<{ resume: UserResume | null }>('/api/user/resumes/feature', { resumeId })
    .then((response) => response.data);
};

export const downloadResume = async (userId: number, fileName: string) => {
  return axios
    .get(`/api/user/resume/download/${userId}/${encodeURIComponent(fileName)}`, {
      responseType: 'blob',
    })
    .then((response) => {
      const blob = new Blob([response.data], { type: response.headers['content-type'] as string });
      const url = window.URL.createObjectURL(blob);

      const opened = window.open(url, '_blank', 'noopener,noreferrer');
      if (!opened) {
        // Fallback: use an anchor click.
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      return response.data;
    });
};

export const simulateCvdesignrWebhook = (data: Record<string, unknown>) => {
  return axios.post('/api/webhook/resume', data).then((response) => response.data);
};

export const parseResume = async (file: File, resumeId: number) => {
  // Normalize the file name before parsing
  const normalizedFile = normalizeFile(file);

  const formData = new FormData();
  formData.append('file', normalizedFile);
  formData.append('resumeId', resumeId.toString());

  return axios
    .post('/api/user/parse-resume', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => response.data);
};
